
import { Vehicle } from "../CRUDs/entities/Vehicle";
import { MaintenanceReport } from "../CRUDs/entities/MaintenanceReport";
import { setQueryParams, removeQueryParams, Filter } from "../jobs-flow/Filter";
import { Paginator } from "../jobs-flow/Paginator";
import { Alarm } from "../CRUDs/entities/Alarm";
import { VehicleInvoice } from "../CRUDs/entities/VehicleInvoice";
import { Accident } from "../CRUDs/entities/Accident";
import Tagify from '@yaireo/tagify';

export default{
    switcher:null,
    filters:{},
    init(){
        this.actions();
        this.initNewDropZone();
        this.listeners();
        this.initSectionSwitcher();
        this.moreInfo();
        this.inputNumber();
    },

    listeners(){
        $('body').off('click', '.data-view.vehicles .data-row .edit')
        .on('click', '.data-view.vehicles .data-row .edit', function(ev){
            new Vehicle($(ev.currentTarget).data('vehicle_id')).openModal('edit');
        })
    },

    moreInfo() {
        $('body').off('click', '.data-view .view-info')
        .on('click', '.data-view .view-info', function (e) {
            let currentElement = $(this);
            $(`.more-info[data-id="${currentElement.data('id')}"]`).toggleClass('d-none');
            currentElement.text(currentElement.text() == 'view' ? 'hide' : 'view');
        });
    },

    actions(){
        let $this=this;
        $('#vehicle-manage').on('click', '.action-row .action', (e) =>{
            let action = $(e.target).data('action');
            let data ={
                action: action,
            };
            switch (action) {
                case 'vehicle':
                    new Vehicle().openModal('create')
                    break;
                case 'invoice':
                    new VehicleInvoice().openModal('create')
                    this.mytag('repairs_add');
                    break;
                case 'accident':
                    new Accident().openModal('create')
                    $('#mask-time').datetimepicker(
                        {format: 'hh:mm a', locale: 'en'}
                    );
                    break;
                case 'maintenance':
                    new MaintenanceReport().openModal('create')
                    break;
                case 'alarms':
                    new Alarm().openModal('create')
                    break;
                default:
                    break;
            }
        });
    },

    inputNumber(id ='') {
        if (id == '') return false;
        $('.' + id).keydown(function(e){
            if ( event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 ||
                (event.keyCode == 65 && event.ctrlKey === true) ||
                (event.keyCode >= 35 && event.keyCode <= 39)) {
                return;
            } else {
                if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105 )) {
                    event.preventDefault();
                }
            }
        });
    },

    initNewDropZone(){
        if(window.location.pathname.startsWith('/vehicles-management')){
            this.id = '';
            this.urlRoot = '/vehicles-mangement/';
            this.vehicle =  new Vehicle();
        }
    },

    initSectionSwitcher(){
        if($('.switcher[data-area="vehicle-manage"]').length){
            $('.switcher[data-area="vehicle-manage"]').off('init-switcher').on('init-switcher', ev=>{
                let evData = ev.detail
                this.switcher = evData?.switcher
                for(let id of this.switcher.sectionIdList){
                    let url = new URL(window.location.href)
                    if(!url.searchParams.has('entity_class'))
                        setQueryParams({'entity_class': id});
                    let filter = new Filter(id[0])
                    this.filters[id[0]] = filter
                    let paginator = new Paginator(id[0]+'s', 10, false, filter)
                    filter.paginator = paginator
                    filter.main()
                }
                const currentURL = new URL(window.location.href)
                if(currentURL.searchParams.has('entity_class')){
                    this.switcher.switchMenu(currentURL.searchParams.get('entity_class'),false)
                    this.filters[currentURL.searchParams.get('entity_class')].showFilter()
                }
            }).on('afterswitch', ev=>{
                let evData = ev.detail
                const section = evData.activeSections[0]
                removeQueryParams();
                setQueryParams({'entity_class': section.id});
                this.filters[section.id].showFilter()
            })
        }  
    },

    mytag(elementId = '', maxTags=-1, addOpts={}) {
        if (elementId == '') return false;
        var whitelist = window.tagifyWhiteList;
        var input = document.querySelector('#' + elementId);
        let addParams = maxTags > 0 ? {maxTags} : {}
        if(input) {
            var tagify = new Tagify(input, {
                enforceWhitelist: true,
                delimiters: null,
                keepInvalidTags: false,
                ...addParams,
                whitelist: whitelist,
                dropdown: {
                    maxItems: 20,
                    position: "text",
                    enabled: 0
                },
                ...addOpts
            });
        }
    },
}
